import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';

export interface GoogleMapDecodedAddress {
  location: google.maps.LatLngLiteral;
  center: google.maps.LatLngLiteral;
}

@Injectable({ providedIn: 'root' })
export class GoogleMapService {
  geocodeAddress(address: string): Observable<GoogleMapDecodedAddress> {
    return new Observable((observer: Subscriber<GoogleMapDecodedAddress>) => {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address }, (results: any, status: any) => {
        if (status !== 'OK') {
          observer.error(status);
          return;
        }

        const location = results[0].geometry.location;
        const center = { lat: location.lat(), lng: location.lng() };

        observer.next({ location, center });
        observer.complete();
      });
    });
  }
}
